export default __webpack_public_path__ + "static/media/(21).810db2d5.jpg";